// extracted by mini-css-extract-plugin
export var container = "PublicationOrDocumentLinkTemplate-module--container--iI0CX";
export var containerLink = "PublicationOrDocumentLinkTemplate-module--container-link--5KmS4";
export var linkHostname = "PublicationOrDocumentLinkTemplate-module--link-hostname--KprJY";
export var documentLink = "PublicationOrDocumentLinkTemplate-module--document-link--Jrja5";